import React from 'react';

import ProfileDisplay from './ProfileDisplay';

export function MyProfile() {
  return <ProfileDisplay data-test="my-profile-route" />;
}

export default MyProfile;
